import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import NmbrPayroll from './NmbrPayroll';
import _ from 'lodash';

class NmbrPaySchedule extends DomainObject {
  title;
  nextPayrolls = [];
  businessEntityId;
  businessEntityName;

  _relations = {
    nextPayrolls: [NmbrPayroll]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      title: observable,
      nextPayrolls: observable,
      businessEntityId: observable,
      businessEntityName: observable,
      sortedNextPayrolls: computed
    });

    this.merge(other);
  }

  get sortedNextPayrolls() {
    return _.sortBy(this.nextPayrolls, p => p.type === 'regular' ? 0 : 1);
  }
}

export default NmbrPaySchedule;
